var React = require('react');

function MenuHamburgerIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0H19V2H0V0ZM0 5H19V7H0V5ZM19 10H0V12H19V10Z","fill":"#191C1F"}));
}

MenuHamburgerIcon.defaultProps = {"width":"19","height":"12","viewBox":"0 0 19 12","fill":"none"};

module.exports = MenuHamburgerIcon;

MenuHamburgerIcon.default = MenuHamburgerIcon;
